module.exports = __webpack_public_path__ + "static/img/sc-bg.2206b11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sc-bg.svg
// module id = kgJE
// module chunks = 1